import {OAuthManager} from './oauth';
import {useEffect, useState} from 'react';

export const useCheckAuth = (oauthManager: OAuthManager) => {
    const [checking, setChecking] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [token, setToken] = useState<string | null>(null);

    useEffect(() => {
        const check = async () => {
            const authed = await oauthManager.isAuthenticated();
            const token = await oauthManager.jwtForApi();
            setIsAuthenticated(authed);
            setChecking(false);
            setToken(token);
        };
        check();
    }, [oauthManager]);

    return {checking, isAuthenticated, token};
}
